import { tab } from "@testing-library/user-event/dist/tab";
import React from "react";
import { useSelector } from "react-redux";
import UploadButton from "./UploadButton";
import { getPopoverByName } from "../../../utils";
import { Tooltip } from "../Tooltip";

const Sidebar = ({
  title,
  titleIcon,
  tabs,
  onTabSelect,
  uploadProps,
  uploadButton,
  isDisabled = false,
  activeIndex,
  className,
}) => {
  const { subTab } = useSelector((state) => state.ui);
  // const trial = useSelector((state) => state?.user?.details?.data?.trial);
  // const tabs = getPopoverByName(title, trial).tabs;
  const selectedIndex = activeIndex ?? subTab;
  return (
    <div
      className={`relative w-1/5 bg-white border-r-2 border-gray-200 ${
        className || ""
      }`}
    >
      <div className="flex items-center justify-start pl-4 py-4 bg-gradient-to-b from-gray-300 to-gray-100 to-90%">
        <img src={titleIcon} alt={""} className="w-4 h-4 mr-2" />
        <span className="text-base">{title}</span>
      </div>
      <div className="text-sm px-2 space-y-2 mt-4 h-full max-h-[calc(100%_-_120px)] overflow-visible">
        {tabs.map((item, tabIndex) => {
          return (
            <div
              key={"popover-menu" + item.name}
              onClick={() => {
                console.log("disabled", !item.disabled || !isDisabled);

                !(item.disabled || isDisabled) && onTabSelect(tabIndex);
              }}
              className={`${
                item.disabled ? "cursor-auto" : "cursor-pointer"
              } relative group `}
            >
              {item.tooltipMessage && (
                <Tooltip className={"left-[80%] top-[0%] w-[800px]"}>
                  {item.tooltipMessage}
                </Tooltip>
              )}
              <div
                className={`py-2 px-0.5 rounded-lg  flex items-center space-x-2 ${
                  item.disabled ? "" : "hover:font-bold hover:bg-gray-200"
                } ${selectedIndex === tabIndex ? "drop-shadow" : ""}`}
              >
                {item.icon && (
                  <div>
                    <img
                      src={`${
                        selectedIndex !== tabIndex ? item.icon : item.iconHover
                      }`}
                      alt={tab.name}
                      className={`w-5 h-5  ${
                        selectedIndex === tabIndex
                          ? " text-vb-pop-sidebar-highlight"
                          : "text-gray-700"
                      }`}
                    />
                  </div>
                )}
                <span
                  className={
                    item.disabled || isDisabled
                      ? "text-gray-500"
                      : selectedIndex === tabIndex
                      ? "us text-vb-violet font-bold "
                      : "us text-gray-700"
                  }
                >
                  {item.name}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {uploadButton && <UploadButton {...uploadButton} />}
    </div>
  );
};

export default Sidebar;
